<template>
  <div>
    <app-warp :title='pageSet.items.index.params.title'>
      <template #app-content>
        <div style="min-height:100%;background-color:#fc8c35" :style="'background-size:100%;background-image:url('+oss+'/web_base_assets/scan/trunTableDefault.png)'" class="moduleMain">
          <template v-for="(item,key) in pageSet.items" :key="key">
            <div  @click.stop="selectModule(key)"  v-if="activeKey==key">
              <component :is="key" :data="item" />
            </div>
          </template>
        </div>
      </template>
      <template #app-sider>
        <a-radio-group v-model:value="activeKey" button-style="solid" @change="changePage" class="m-b-20 m-l-20">
          <a-radio-button value="index">首页</a-radio-button>
          <a-radio-button value="win">中奖页</a-radio-button>
          <a-radio-button value="notWinning">未中奖</a-radio-button>
          <a-radio-button value="orderFrom">填写实物订单</a-radio-button>
          <a-radio-button value="collect">收集资料</a-radio-button>
          <a-radio-button value="repeat">重复领奖</a-radio-button>
          <a-radio-button value="success">领奖成功</a-radio-button>
        </a-radio-group>
        <div class="moduleContent " style="width:100%;margin-left:20px">
          <a-form :model="form" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}">
            <template v-for="(value,index) in formCreateData" :key="index+activeKey">
              <a-form-item :label="value.label" :help="value.help">
                <!-- 普通表单 -->
                <template v-if="value.stamp=='input'">
                   <a-row :gutter="16">
                    <a-col :span="10">
                      <a-input v-model:value="modelRef[value.key][value.name]" :maxLength="value.maxLength" :type="value.type" :help="value.help"/>
                    </a-col>
                    <a-col :span="12" v-if="value.defaultValue">
                      <a href="javascript:;" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认设置</a>
                    </a-col>
                  </a-row>
                </template>
                    <!-- 多选框 -->
                <template v-if="value.stamp=='checkbox'">
                  <a-checkbox-group :options="value.options" v-model:value="modelRef[value.key][value.name]" />
                </template>
                       <!-- 滑动 -->
                  <template v-if="value.stamp=='slider'">
                    <a-slider :tip-formatter="(value)=>value+'%'"
                      v-model:value="modelRef[value.key][value.name]" :max="100" style="width:300px"/>
                  </template>
                <!-- 选择框 -->
                <template v-if="value.stamp=='select'">
                  <a-select v-model:value="modelRef[value.key][value.name]" :style="{width:'270px'}" placeholder="请选择">
                    <a-select-option v-for='item in value.options' :key='item.value' :value="item.value">{{item.label}}
                    </a-select-option>
                  </a-select>
                </template>
                <template v-if="value.stamp=='singleImage'">
                        <a-row :gutter="16">
                    <a-col :span="10">
                     <material :groupType='1' :image="modelRef[value.key][value.name]" :max="1" v-on:handlechoose="(data)=>{
                    modelRef[value.key][value.name]=data}" v-on:handledel="modelRef[value.key][value.name]=''" />
                    </a-col>
                    <a-col :span="12" v-if="value.defaultValue">
                      <a href="javascript:;" v-if="value.defaultValue" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认图</a>
                    </a-col>
                  </a-row>
                </template>
                <!-- 单选框 -->
                <template v-if="value.stamp=='radio'">
                  <a-radio-group :options="value.options" v-model:value="modelRef[value.key][value.name]" />
                </template>
              </a-form-item>
            </template>
          </a-form>
        </div>
      </template>
    </app-warp>
  </div>
</template>

<script>
import win from "./components/win.vue";
import repeat from "./components/repeat.vue";
import double from "./components/double.vue";
import collect from "./components/collect.vue";
import index from "./components/index.vue";
import notWinning from "./components/notWinning.vue";
import success from "./components/success.vue";
import orderFrom from "./components/orderFrom.vue";
import config from "@/config";
import forms from "./form";
import * as Icon from "@ant-design/icons-vue";
import { onMounted, reactive, ref, toRefs, watch, watchEffect } from "vue";
import {getCanvas} from '@/libs/html2canvas'
export default {
  components: { win,repeat, collect, double,index,notWinning,orderFrom,success, ...Icon },
  name: "turnTable",
  props: {
    template_data: Object,
  },
  setup(props, { emit }) {
    // 模板页当前页面 记录
    const state = reactive({
      active: "index",
    });
    const activeKey = ref('index');
    var pageSet = ref({
      items: {
        index: {
          style: {
            backgroundImage: "/web_base_assets/scan/trunTableDefault.png",
            backgroundColor: "#fa6455",
            top:45
          },
          params:{
            title:'大转盘活动',
            is_show_content:true,
            is_show_list:true,
            is_show_guide:false,
            showKey:['store','user']
          }
        },
        win: {
          style: {
            titleColor:"#ffffff",
            awardColor:"#ffffff",
            backgroundImage: "",
            backgroundColor:"#FF3030",
            backgroundButtomImage:"",
            buttonColor: "#FFAE59",
            buttonTextColor:"#ffffff",
            des_color: "#333333",
            btn_color: "#333333",
          },
          params:{
            jifenTips:"已到账，请前往会员中心查看",
            rebTips:"红包将在24小时内发放",
            envelopesRebTips:"累计满0.3元即可提现"
          }
        },
        notWinning: {
          style: {
            backgroundImage: "/web_base_assets/scan/packages.png",
            backgroundButtomImage: "",
            backgroundColor:"#ffffff",
            tipsColor:"#8E0707",
            buttonColor:"#FFAE59",
            buttonTextColor:"#ffffff",
          },
          params:{
            tips:"谢谢您的参与,可前往会员中心查看历史中奖信息"
          }
        },
         success: {
          style: {
            backgroundImage: "/web_base_assets/scan/packages.png",
            backgroundButtomImage: "",
            backgroundColor:"#ffffff",
            tipsColor:"#8E0707",
            buttonColor:"#FFAE59",
            buttonTextColor:"#ffffff",
          },
          params:{
            tips:"奖品领取成功可前往会员中心，查看中奖信息"
          }
        },
        orderFrom: {
           style: {
            titleColor:"#333333",
            backgroundImage: "",
            backgroundColor: "#ffffff",
            buttonColor:"#FF0E41",
            buttonTextColor:"#ffffff",
            backgroundButtomImage: "",
          },
        },
        repeat: {
        style: {
            backgroundImage: "/web_base_assets/scan/packages.png",
            backgroundButtomImage: "",
            backgroundColor:"#ffffff",
            tipsColor:"#8E0707",
            buttonColor:"#FFAE59",
            buttonTextColor:"#ffffff",
          },
          params:{
            tips:"奖品已被领取"
          }
        },
        collect: {
         style: {
            titleColor:"#333333",
            desColor:'#999999',
            backgroundImage: "",
            backgroundColor: "#ffffff",
            buttonColor:"#FF0E41",
            buttonTextColor:"#ffffff",
            backgroundButtomImage: "",
          },
        },
        double: {
          style: {
            backgroundImage: "/web_base_assets/scan/double.gif",
            color: "#FDE1A2",
          },
          params:{
            tips:'尊贵的会员 您的奖项已倍增'
          }
        },
      },
    });
    watchEffect(() => {
      if(JSON.stringify(props.template_data)!='{}'){
        pageSet.value = props.template_data;
          if (pageSet.value.items.index&&pageSet.value.items.index.params&&!Object.prototype.hasOwnProperty.call(pageSet.value.items.index, 'is_show_guide')) {
            pageSet.value.items.index.params.is_show_guide = false;
          }
      }
    });
    var modelRef = ref();
    const moduleIndex = ref(0);
    // 读取模块表单数据
    var formCreateData = ref({});
    const formCreate = () => {
      forms.forEach((element) => {
        if (element.type == state.active) {
          formCreateData.value = element.formItems;
        }
      });
      console.log(formCreateData.value)
    };
    // 模块
    const selectModule = (type) => {
      modelRef.value = pageSet.value.items[type];
      state.active = type;
      formCreate();
    };
    const initData = () => {
      formCreate();
    };
    const oss = config.oss[process.env.VUE_APP_type];
    onMounted(() => {
      selectModule(activeKey.value)
      initData();
    });
    const submit = () => {
      emit("submit", pageSet.value);
      return pageSet.value;
    };
    const getThumb = () => {
          // 选中首页 用于截图
        return new Promise((resolve,reject)=>{
            // 选中首页 用于截图
          activeKey.value='index'
          var element= document.getElementById('app-subject')
            let imgArr = document.querySelectorAll('img')
             imgArr = Array.from(imgArr)
              let timer = setInterval(() => {
                clearInterval(timer)
                if (imgArr.length !== i) {
                    console.error('超时')
                }
            }, 10000);
            var i=0;
            [...imgArr].forEach((dom) => {
                 getUrlBlob(dom.src, ((blob) => {
                if (blob !== false) {
                    dom.src = blob
                }
                i++
                // 校验是否全部替换完毕
                    if ((imgArr.length) === i) {
                        clearInterval(timer)
                           // 大转盘比较特殊先把 大转盘的canvas 转化了  再转换整图
                                  setTimeout(() => {
                        getCanvas(element).then(res=>{
                          console.log(res)
                            resolve(res.image)
                        }).catch(()=>{
                            reject('/web_base_assets/scan/turnTableExample.png')
                        })
                            }, 500);

                    }
                }))
            })
     
      })
      // return "";
    };
    var getUrlBlob = (url, callback) => {
        const str = url.substring(0, 50)
        // 避免重复加载
        if (str.includes('blob:')) {
            return callback(false)
        }
        // 避免img未有src属性的情况，导致未返回
        if (!str) {
            return callback(false)
        }
        let canvas = document.createElement("canvas")
        let ctx = canvas.getContext("2d")
        let img = new Image
        img.crossOrigin = 'Anonymous'
        img.src = url
        img.onload = function () {
            canvas.height = img.height
            canvas.width = img.width
            ctx.drawImage(img, 0, 0)
            try {
                canvas.toBlob((blob) => {
                    callback(URL.createObjectURL(blob))
                })
            } catch (err) {
                callback(img.src)
                console.error('转换失败，使用原图', err)
            }
            canvas = null
        }
      
    }
    const changePage = (e) => {
      state.value = e.target.value;
      selectModule(activeKey.value)
      formCreate();
    };
    return {
      activeKey,
      pageSet,
      selectModule,
      formCreateData,
      ...toRefs(state),
      modelRef,
      moduleIndex,
      oss,
      submit,
      getThumb,
      changePage
    };
  },
};
</script>
<style lang="less" scoped>
@import url("../module.less");
</style>